import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logos/Main/Myceleblogo.png'


const _hoisted_1 = { class: "offcanvas-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_0,
  alt: "logo",
  style: {"max-height":"40px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "ri-close-fill" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "offcanvas-body" }
const _hoisted_6 = { class: "accordion-item" }
const _hoisted_7 = { class: "accordion-item" }
const _hoisted_8 = { class: "accordion-item" }
const _hoisted_9 = { class: "accordion-item" }
const _hoisted_10 = { class: "accordion-item" }
const _hoisted_11 = { class: "accordion-item" }
const _hoisted_12 = { class: "accordion-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BAccordion = _resolveComponent("BAccordion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'responsive-navbar offcanvas offcanvas-end',
      { show: _ctx.stateStoreInstance.open },
    ]),
    tabindex: "-1",
    id: "navbarOffcanvas"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _ctx.handleClick,
        class: "logo d-inline-block"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("button", {
        type: "button",
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_BAccordion, { free: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" HOME ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/services",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SERVICES ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/our-team",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" GET YOUR WISH ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/client",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR CLIENTS ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/about-us",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" ABOUT US ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/success-stories",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR WORKS ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: "/contact-us",
              class: "accordion-link",
              onClick: _ctx.handleClick,
              style: {"color":"black !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CONTACT US ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ])
  ], 2))
}